import { useRecoilState } from 'recoil';
import { IRole } from 'shared/types';

import { roles } from './atoms';

export const useRolesActions = () => {
  const [rolesValue, setRolesValues] = useRecoilState(roles);
  
  const setRoles = async (valor:IRole[]) => {
    setRolesValues(valor);
  };
 
  return {
    setRoles
  };
};
